import { defineStore } from 'pinia';
import { Observable, tap } from 'rxjs';
import { computed, ref } from 'vue';

import { AgoInfo, PrettyTemplate } from '~/domain';
import { TemplateDto, fetchBookkeeperTemplates } from '~/services';
import { fetchOnlineHelpInfo } from '~/services/api/online-help/online-help.api.ts';
import { formatDate } from '~/utils';

/** App context initialization store */
export const usePrimordialSoupStore = defineStore('primordial-soup-store', () => {
	const _templates = ref<Array<PrettyTemplate>>([]);
	const _agoInfo = ref<AgoInfo>();

	const fetchTemplates = (): Observable<Array<TemplateDto>> => {
		return fetchBookkeeperTemplates().pipe(
			tap((templateDtos: Array<TemplateDto>) => {
				_templates.value = templateDtos
					.map(dto => ({
						...dto,
						title: dto.name,
						formattedUpdatedAt: formatDate(dto.updatedAt)
					}))
					.sort((a, b) => a.name.localeCompare(b.name));
			})
		);
	};

	const fetchAgoInfo = (): Observable<AgoInfo> => {
		return fetchOnlineHelpInfo().pipe(
			tap(agoInfo => {
				_agoInfo.value = agoInfo;
			})
		);
	};

	const reset = () => {
		_templates.value = null;
	};

	return {
		/** Computed */
		agoInfo: computed(() => _agoInfo.value),
		templates: computed(() => _templates.value ?? []),

		/** Functions */
		fetchAgoInfo,
		fetchTemplates,
		reset
	};
});
